import {AgyleAssessmentIcon} from '../../../../../components/icons/agyle';
import {useDispatch} from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {openPatientForm} from '../../../../../store/reducers/patientContext';

const useStyles = makeStyles((theme) => ({
    assessmentButton: {
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        paddingTop: 5,
        '&:hover': {
            backgroundColor: theme.palette.inPatient.accordionBackground,
            borderRadius: 6,
            cursor: 'pointer',
        },
        '&.disabled': {
            opacity: 0.5,
            '&:hover': {
                cursor: 'not-allowed',
            },
        }
    },
    assessmentDescription: {
        fontSize: 'small',
        fontWeight: 'bold',
    },
    icon: {
        color: theme.palette.mode === 'light' ? "#D1D4D9" : "#ffffff",
    }
}));

// TODO Add history button here [HistoryFormButton]
const AssessmentButton = ({assessment, disableSave}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const openForm = (code) => {
        if (disableSave) return null;
        dispatch(openPatientForm(code));
    };

    return (
        <div
            className={clsx(classes.assessmentButton, disableSave && 'disabled')}
            onClick={() => openForm(assessment?.code)}
        >
            <AgyleAssessmentIcon className={classes.icon}/>

            <span className={classes.assessmentDescription}>
                {assessment?.description}
            </span>
        </div>
    );
};

export default AssessmentButton;